export const _ADD                   = "E43+i6PpsdJHP0PtVyVblQ==";
export const _EDIT                  = "63oUZv/n6lrt/spqKW6L3Q==";
export const _VIEW                  = "XVXzpAdCW7hj/ewDXnuaZg==";
export const _DELETE                = "8AU6e3k8EUVOk3dQWSRowTe7y0wbFwo7oU9mUB9khT0=";
export const _RECOVER               = "xBeZIPhkipLYMXFEoz6E1FzlYE+88xazvgiqO3AKGLY=";
export const _LIST                  = "oR2Px32h74Q60hQReAaiGA==";
export const _TRASH                 = "/dEUdE7CEDVi7xc+ZxhgKQ==";
export const _LIST_OPERATION_CARGO  = "/SDnzTnZLYp33hszbCjP5GGChnLkY3ZXCHZzAS1eFs4=";
export const _LIST_OPERATION_PORT   = "uCs6Ii2xacFVayPtYoeTXJHkw17f26b/y1YFg62g1MI=";